import {
    communityApplyFilterCriteria,
    communityClearFilterCriteria,
    communitySetFilter
} from "../../../actions/community-actions"

import buildFilterWidgetContainer from "../../common/build-filter-widget-container"
import CommunityFilterFormContainer from "./CommunityFilterFormContainer"

export default buildFilterWidgetContainer(
    CommunityFilterFormContainer,
    communityClearFilterCriteria,
    communityApplyFilterCriteria,
    communitySetFilter
)
